import script from "./userLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./userLogin.vue?vue&type=script&setup=true&lang=js"

import "./userLogin.vue?vue&type=style&index=0&id=2688a2f0&lang=css"
import "./userLogin.vue?vue&type=style&index=1&id=2688a2f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2688a2f0"]])

export default __exports__